export default class {
    static getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    static format_currency(amount) {
        Number(amount).toLocaleString() + ' SAR'
    }
    static toTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    }
    static format_date(date) {
        const d = new Date(date)
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    }
}